import styled from '@emotion/styled';

export const Link = styled('a')`
  font-size: ${props => props.theme.fonts.size[3]}px;
  font-weight: ${props => props.selected ? props.theme.fonts.weight[3] : props.theme.fonts.weight[1]};
  text-decoration: none;
  color: ${props => props.selected ? props.theme.colors.primary[0] : props.theme.colors.neutral[1]};
  white-space: nowrap;

  &:visited {
    color: ${props => props.selected ? props.theme.colors.primary[0] : props.theme.colors.neutral[1]};
  }
  &:focus, &:active, &:hover {
    text-decoration: none;
    color: ${props => props.theme.colors.primary[0]};
  }
`;

export const PlaceholderLink = styled('span')`
  display: inline-block;
  width: 55px;
  height: 1em;
  background-color: ${props => props.theme.colors.neutral[4]};
`;
